import { checkMobileExist } from './api/user';

export const lengthLimitNormalizer = limit => (v, prev) => (
  v.length > limit ? prev : v
);

export const lengthValidator = (min, max) => (v) => {
  if (!v) {
    return 'required';
  } else if (min === max) {
    return v.length === min
      ? null
      : `should be exact ${min} chars`;
  } else if (v.length < min) {
    return `should be more than ${min} chars`;
  } else if (v.length > max) {
    return `should be less than ${min} chars`;
  }
  return null;
};

export const cellphoneNumberNormalizer = lengthLimitNormalizer(11);

export const nameNormalizer = lengthLimitNormalizer(30);

export const passwordNormalizer = lengthLimitNormalizer(12);

export const heightWeightNormalizer = lengthLimitNormalizer(3);

export const cellphoneNumberValidator = lengthValidator(11, 11);

// const sleep = ms => new Promise(resolve => setTimeout(resolve, ms));

export const cellphoneExistValidator = ({ cellphone }) => (
  checkMobileExist({ cellphone }).then(({ registered }) => {
    if (registered) {
      // noinspection UnnecessaryLocalVariableJS
      const error = {
        cellphone: 'taken'
      };
      throw error;
    }
  })
);

export const verificationCodeNormalizer = lengthLimitNormalizer(6);

export const verificationCodeValidator = lengthValidator(6, 6);

export const required = v => (v && (v.length > 0 || typeof v.length === 'undefined') ? null : 'required');

const passwordRegex = /^[A-Za-z0-9]+$/gi;
export const passwordLengthValidator = lengthValidator(6, 12);
export const passwordValidator = v => (v.match(passwordRegex) ? null : 'invalid format');

export const genderValidator = v => (v === 1 || v === 2 ? null : 'gender must be chosen');

export const heightWeightValidator = v => (v >= 1 ? null : 'must be larger than 0');

const requiredFields = {
  cellphone: '手机号',
  password: '密码',
  code: '验证码',
  name: '姓名',
  birthday: '出生年月',
};

function parseRequiredFields(err) {
  let result = null;
  Object.keys(requiredFields).map(k => result = (result || err[k] !== 'required' ? result : `请输入${requiredFields[k]}`));
  return result;
}

export function parseError(err) {
    let result = parseRequiredFields(err);
  if (result) {
    return result;
  }
  result = (result || !err.gender) ? result : '请选择性别';
  result = (result || !err.height) ? result : '身高不在有效范围';
  result = (result || !err.age) ? result : '年龄不在有效范围';
  result = (result || !err.weight) ? result : '体重不在有效范围';
  result = (result || !err.medicalHistoryVisited) ? result : '请选择病史';
  result = (result || err.cellphone !== 'taken') ? result : '手机号已注册';
  result = (result || !err.cellphone) ? result : '请正确输入11位手机号';
  result = (result || !err.password) ? result : '密码为6-12位字母数字组合';
  result = (result || !err.code) ? result : '请正确输入6位验证码';
  result = result || '提交失败，请检查网络后重试';
  return result;
}



// WEBPACK FOOTER //
// ./src/validator.js